import type { EventRunnerType } from "app/types/eventType";

export default function EmptyRunner(props: { runner: EventRunnerType }) {
  return (
    <span
      key={"binary" + props.runner.id}
      className={`binary-market-alt__runner--empty `}
    ></span>
  );
}
